/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Offline_UnavailableInputs */



/**
* | output |
* | --- |
* | "Offline voices are not available in this browser." |
*
* @param {Voice_Manager_Offline_UnavailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_offline_unavailable = /** @type {((inputs?: Voice_Manager_Offline_UnavailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Offline_UnavailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les voix hors ligne ne sont pas disponibles dans ce navigateur.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offline-Sprachfunktionen sind in diesem Browser nicht verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le voci offline non sono disponibili in questo browser.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("В этом браузере функция голосового сопровождения в автономном режиме недоступна.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las voces sin conexión no están disponibles en este navegador.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("此浏览器不支持离线语音功能。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このブラウザではオフライン音声は利用できません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस ब्राउज़र में ऑफ़लाइन आवाज़ें उपलब्ध नहीं हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Vozes offline não estão disponíveis neste navegador.")
	return /** @type {LocalizedString} */ ("Offline voices are not available in this browser.")
});